<template>
    <h4
        class="modal-title"
        id="contactModalLabel"
        v-text="headingText"
    ></h4>
</template>

<script>
export default {
    name: 'ModalTitle',

    props: {
        headingText: {
            required: true,
            type: String,
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/Bootstrap/BootstrapVersionFixers/ModalHeading/ModalTitle.vue